/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, Fragment } from "react";
import LayoutWrapper from "./LayoutWrapper";
import {gitRepoConsoleUrl, gitToken} from "../constants";
import Cookies from "js-cookie";
import moment from "moment";



const GitReleasesTemplate2 = () => {

    const iconMap = {
        "New Features": "🚀",
        "Maintenance": "🛠️",
        "Bug Fixes": "🐛",
    };

    const releaseData2 = {
        name: "",
        description: `


        ::Tanvir2::
        features 1


        features 2




        ::New Features::
        features 1
        features 2
        hhhaaa
        h
        n




        ::Maintenance::
        sdsada
        maintenance 1
        maintenance 2

        ::Bug Fixes::
        bug 1
        bug 2
        `,
        released_at: "",
    };

    const parseTextToHTML = (text) => {
        const sections = text.trim().split(/\n\s*\n*::/);


        return sections.map((section, index) => {
            section = section.replace(/[\r\n]{2,}/g, "\n"); // remove blank Newlines

            const lines = section.trim().split("\n");

            const titleMatch = lines[0].match(/:{0,2}(.*?)::/);

            const title = titleMatch ? titleMatch[1].trim() : "Untitled";

            const items = lines.slice(1).map((line) => line.replace(/^- /, '').trim());

            return (
                <Fragment key={index}>
                    <section style={styles.section} >
                        <h2 style={styles.sectionTitle}>{iconMap[title] || '🔹'} {title}</h2>
                        <hr/>

                        <ul style={styles.list}>
                            {items.map((item, idx) => (
                                <li style={styles.listItem} key={idx}>{item}</li>
                            ))}
                        </ul>

                    </section>

                    <br/>
                </Fragment>

            );
        });
    };



    const releaseData = {
        name: "",
        description: ``,
        released_at: "",
    };




    return (
        <div style={styles.container}>
            <header style={styles.header}>
                <h1 style={styles.title}>
                    <strong>
                        Adgrid
                    </strong> {" "}
                    {releaseData.name} Release

                </h1>

                <p style={styles.time}>
                    {moment(releaseData.released_at).fromNow()}
                </p>

            </header>

            {parseTextToHTML(releaseData2.description)}

        </div>
    );

}

const GitReleasesTemplate = ({releaseData, latestReleases, margin}) => {


    const iconMap = {
        "New Features": "🚀",
        "Maintenance": "🛠️",
        "Bug Fixes": "🐛",
    };

    const parseTextToHTML = (text) => {
        //const sections = text.trim().split(/\n\s*\n/);
        const sections = text.trim().split(/\n\s*\n*::/);

        return sections.map((section, index) => {
            /*const lines = section.trim().split("\n");
            const title = lines[0].replace(/::/g, '').trim();
            const items = lines.slice(1).map((line) => line.replace(/^- /, '').trim());*/

            section = section.replace(/[\r\n]{2,}/g, "\n"); // remove blank Newlines
            const lines = section.trim().split("\n");
            const titleMatch = lines[0].match(/:{0,2}(.*?)::/);
            const title = titleMatch ? titleMatch[1].trim() : "Untitled";
            const items = lines.slice(1).map((line) => line.replace(/^- /, '').trim());

            return (
                <Fragment key={index}>
                    <section style={styles.section} >
                        <h2 style={styles.sectionTitle}>{iconMap[title] || '🔹'} {title}</h2>
                        <hr/>

                        <ul style={styles.list}>
                            {items.map((item, idx) => (
                                <li style={styles.listItem} key={idx}>{item}</li>
                            ))}
                        </ul>

                    </section>

                    <br/>
                </Fragment>

            );
        });
    };


    if (margin) {
        margin = "3rem auto";
    } else {
        margin = "3rem";
    }


    return (
        <div style={{...styles.container, margin}}>
            <header style={styles.header}>
                <h1 style={styles.title}>
                    <strong>
                        Adgrid
                    </strong> {" "}
                    {releaseData.name} Release

                </h1>

                {
                    latestReleases === releaseData.name && <div style={styles.tag}>
                        Latest
                    </div>
                }

                <p style={styles.time}>
                    {moment(releaseData.released_at).fromNow()}
                </p>

            </header>

            {parseTextToHTML(releaseData.description)}

        </div>
    );
}

const ReleaseNotes = (props) => {
    const [gitReleases, setGitReleases] = useState(null);
    const [latestReleases, setLatestReleases] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [ableToPaginate, setAbleToPaginate] = useState({prev: false, next: true});

    useEffect(() => {

        getGitComments();

    }, [pageNumber])


    const prevPageNumber = () =>{
        if (pageNumber === 1) {
            setAbleToPaginate({prev: false, next: true});
        }

        setPageNumber(state=> state > 1 ? state-1 : 1);

    }
    const nextPageNumber = () =>{
        if (pageNumber > 1) {
            setAbleToPaginate({prev: true, next: true});
        }
        setPageNumber(state=>state+1)
    }


    const getGitComments = () => {
        fetch(`${gitRepoConsoleUrl}/releases?page=${pageNumber}`, {
            method: "GET",
            headers: {
                "PRIVATE-TOKEN": gitToken
            },
        })
            .then(res=>res.json())
            .then((data)=>{
                const [latest] = data;

                //console.log(data, 'hhh') //released_at
                setGitReleases([]);

                data = data.filter((elm)=>{
                    return elm.name >= "5.0.0";
                })

                let found = data.find((elm)=>{
                    return elm.name === "5.0.0";
                })

                if(!!found){
                    setAbleToPaginate({prev: true, next: false});
                } else {
                    setAbleToPaginate({prev: pageNumber !== 1, next: true});
                }


                if (!data.length) {
                    return;
                }

                setTimeout(()=>{
                    setLatestReleases(latest.name);
                    setGitReleases(data);
                }, 1)

            })
        ;
    }


    const paginationButtons = () => {
        return (
            <div style={styles.paginationContainer}>

                {
                    ableToPaginate.prev ? (
                        <button style={styles.button} onClick={prevPageNumber}>
                            <span style={styles.icon}>&lt;</span> Prev
                        </button>
                        ) : (
                        <button style={styles.disableButton} type="button">
                            <span style={styles.icon}>&lt;</span> Prev
                        </button>
                    )
                }

                {
                    ableToPaginate.next ? (
                        <button style={styles.button} onClick={nextPageNumber}>
                            Next <span style={styles.icon}>&gt;</span>
                        </button>
                    ) : (
                        <button style={styles.disableButton} type="button">
                            Next <span style={styles.icon}>&gt;</span>
                        </button>
                    )
                }



            </div>
        );
    }


    return (
        <>

            {
                gitReleases && gitReleases.map((releaseData, index) =>
                    <GitReleasesTemplate
                        key={index}
                        releaseData={releaseData}
                        latestReleases={pageNumber === 1 ? latestReleases: ""}
                    />
                )
            }

            {
                gitReleases && paginationButtons()
            }

        </>
    );
};

const styles = {
    container: {
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f8f8f8",
        color: "#000000",
        padding: "20px",
        //maxWidth: "800px",
        margin: "3rem auto",
        border: "1px solid #ddd",
        borderRadius: "10px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    },
    header: {
        textAlign: "center",
        marginBottom: "30px",
    },
    title: {
        display: "inline-block",

        margin: 0,
        fontSize: "28px",
        color: "#333",
    },
    tag: {
        display: "inline-block",
        backgroundColor: "#f1f5f9",
        color: "#008d02",
        padding: "5px 10px",
        //marginTop: "10px",
        marginLeft: "10px",
        borderRadius: "15px",
        fontSize: "14px",
        border: "1px solid #008d02",
    },
    time: {
        marginTop: "5px",
        color: "#555",
    },
    section: {
        marginBottom: "20px",
    },
    sectionTitle: {
        marginBottom: "10px",
        fontSize: "22px",
        color: "#333",
    },
    list: {
        marginLeft: "2rem",
        listStyle: "disc",
        padding: 0,
    },
    listItem: {
        marginBottom: "10px",
    },
    link: {
        color: "#007bff",
        textDecoration: "none",
    },

    /*pagination*/

    paginationContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        borderRadius: "5px",
        padding: "5px",
        backgroundColor: "#fff",
    },
    button: {
        border: "1px solid #ddd",
        backgroundColor: "#fff",
        padding: "10px 20px",
        fontSize: "16px",
        color: "#333",
        borderRadius: "3px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "5px",
    },

    disableButton: {
        border: "1px solid #ddd",
        backgroundColor: "#e0e0e0",
        padding: "10px 20px",
        fontSize: "16px",
        color: "#989898",
        borderRadius: "3px",
        cursor: "not-allowed",
        display: "flex",
        alignItems: "center",
        gap: "5px",
    },
    icon: {
        fontSize: "14px",
    },
};

export default ReleaseNotes;
